import {StyledDataGrid} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/StyledDataGrid';

export interface WeaveTraceConfig {
  savedViewDefinition?: string;
  currentStep?: number | null;
}

export type WeaveStyleDataGridColumns = React.ComponentProps<
  typeof StyledDataGrid
>['columns'];

export interface TraceData {
  callId: string;
  entity: string;
  project: string;
}

export const WEAVE_TRACE_PANEL_TYPE = 'Weave Trace';
